const config = {
  env: "prod",
  // apiUrl: "http://localhost:5543/admin/",
  apiUrl: "https://vedicvoyages.com/api/admin/",
  // apiUrl: "http://13.233.11.248:5569/admin",
  // apiUrl: "https://api.vedicvoyages.uk/admin/",
  // shipRocketApiUrl: "https://apiv2.shiprocket.in/v1/external/"
};

export default config;
